import { GUEST_INPUT_LIMITS } from '@repo/lib';
import { z } from '../zod';

export const SaveBookingGuestBodyValidationSchema = z.object({
  name: z.string().trim().max(GUEST_INPUT_LIMITS.name).optional(),
  email: z.string().trim().max(GUEST_INPUT_LIMITS.email).optional(),
  answers: z
    .array(
      z.object({
        fieldId: z.string(),
        value: z.string().max(GUEST_INPUT_LIMITS.answerValue).optional(),
        values: z
          .array(z.string().max(GUEST_INPUT_LIMITS.answerValuesItem))
          .max(GUEST_INPUT_LIMITS.answerValues)
          .optional(),
        meta: z.record(z.string(), z.unknown()).optional(),
      }),
    )
    .max(GUEST_INPUT_LIMITS.answers)
    .optional(),
});

export type SaveBookingGuestBody = z.infer<typeof SaveBookingGuestBodyValidationSchema>;

export const BookingGuestRowValidationSchema = z
  .object({
    position: z.number(),
    ticketType: z.string(),
    // Unset until the booking's tickets are created.
    ticketId: z.string().optional(),
    ticketTypeName: z.string().optional(),
    name: z.string().optional(),
    email: z.string().optional(),
    answers: z.array(z.record(z.string(), z.unknown())).optional(),
    added: z.boolean(),
    canceled: z.boolean().optional(),
  })
  .loose();

// What the booker sees of their booking's guests: one row per ticket, and whether they can still
// change them.
export const BookingGuestsValidationSchema = z.object({
  rows: z.array(BookingGuestRowValidationSchema),
  questions: z.array(z.record(z.string(), z.unknown())),
  guestFormLayout: z.array(z.record(z.string(), z.unknown())).nullish(),
  status: z.string(),
  emailDomains: z.string(),
  heading: z.string().optional(),
  description: z.string().optional(),
  saveButton: z.string().optional(),
  allAdded: z.boolean(),
  editable: z.boolean(),
  lockedReason: z.string().nullable(),
});

export const ReviewBookingGuestBodyValidationSchema = z.object({ reviewed: z.boolean() });

export const MerchantSaveBookingGuestResponseValidationSchema = z.object({
  guests: BookingGuestsValidationSchema.loose(),
  warnings: z.array(z.string()),
});
